// This file was automatically generated from app.shared.dialog.enterpriseImportPatient.html.
// Please don't edit this file by hand.

goog.provide('el8.template.app.shared.dialog.enterpriseImportPatient');

goog.require('soy');
goog.require('soy.StringBuilder');


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.app.shared.dialog.enterpriseImportPatient.content = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<form><div class="overlayContainer"><h4 class="el8HeaderNoBorder mb10">To access this chart, please confirm:</h4><select class="mb10" name="primaryPhysicianUserId">', (opt_data.physicianUsers.length > 1) ? '<option value="" disabled>select a provider...</option>' : '');
  var userList8042 = opt_data.physicianUsers;
  var userListLen8042 = userList8042.length;
  for (var userIndex8042 = 0; userIndex8042 < userListLen8042; userIndex8042++) {
    var userData8042 = userList8042[userIndex8042];
    output.append('<option value="', soy.$$escapeHtml(userData8042.id), '">', soy.$$escapeHtml(userData8042.name), '</option>');
  }
  output.append('</select><div class="el8StandardFontSize mb20">is a new provider for this patient and will automatically share information with current providers caring for this patient in <span class="el8Medium">', soy.$$escapeHtml(opt_data.enterpriseName), '</span>.</div><div class="el8StandardFontSize el8777">By selecting "Agree & Continue" below, the patient\'s current providers in <span class="el8Medium">', soy.$$escapeHtml(opt_data.enterpriseName), '</span> will be notified of the sharing relationship.</div><div class="loading-indicator"></div></div></form>');
  if (!opt_sb) return output.toString();
};
